<template>
    <div>
        <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
        <a target="_blank" :href="file(data)" download>
            <span>
                <i class="mdi mdi-circle pr-1" :class="{'mdi-image' : data.type == 'image', 'mdi-file' : data.type == 'pdf', 'mdi-play' : data.type == 'video'}"></i>
            </span>{{data.translation.name}}
        </a>
    </div>
</template>

<script>
export default {
    name: 'ContentUndefinedFile',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        file({
            host,
            original_file,
        }, size = 'original') {
            // Verificar se temos uma URL assinada disponível no localStorage
            const signedUrls = localStorage.getItem(`content_${this.data.id_lesson_content}_download_urls`);

            if (signedUrls) {
                const urls = JSON.parse(signedUrls);
                if (urls && urls.download) {
                    // Se temos uma URL assinada para download, usamos ela
                    return urls.download;
                }
            }

            return `/app/files/download/${this.data.id_lesson_content}/${this.data.secret}/show`;
        },
    },

};
</script>

<style>

</style>
